exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".number-format{font-weight:600}", "", {"version":3,"sources":["/divvit-app/client/components/NumberFormat/client/components/NumberFormat/style.styl","/divvit-app/client/components/NumberFormat/style.styl"],"names":[],"mappings":"AAAA,eAEE,eAAA,CCAD","file":"style.styl","sourcesContent":[".number-format\n  // white-space: nowrap\n  font-weight: 600\n",".number-format {\n  font-weight: 600;\n}\n/*# sourceMappingURL=client/components/NumberFormat/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/components/NumberFormat/style.styl
// module id = 527
// module chunks = 0